import { Component, ElementRef, OnInit, ViewChild, Renderer2 } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { BoletoService } from "./boleto.service";

@Component({
    templateUrl: './pdf.html',
  })
  export class PDFComponent implements OnInit{

    @ViewChild('Padrao', { static: true }) el: ElementRef;  
    @ViewChild('botoes', { static: true }) el2: ElementRef;     

    constructor(private activatedRoute: ActivatedRoute,private boletoService: BoletoService,private hostElement: ElementRef,private renderer: Renderer2){}
      colunateste:string;

          ngOnInit():void{
          var b64 = this.boletoService.valorhtml;
          var bin = atob(b64);

          //Plano B para navegadores IE antigos (pois não suportam  data URIs dentro de <object> ou <iframe> para exibir PDF embutido.
		  if (window.navigator && (window.navigator as any).msSaveOrOpenBlob)
          {

            var byteCaracteres = atob(b64);
            var byteNumeros = new Array(byteCaracteres.length)
            for (var i = 0; i < byteCaracteres.length; i++) {
              byteNumeros[i] = byteCaracteres.charCodeAt(i);
            }
            var byteArr = new Uint8Array(byteNumeros);
            var blob = new Blob([byteArr], {
              type: 'application/pdf'
            });
            (window.navigator as any).msSaveOrOpenBlob(blob, 'boleto_' + Date.now() + '.pdf');
            
          }
          else {
            var obj = document.createElement('object');
            obj.title = "Boleto PDF"
            obj.name = "Boleto PDF"
            obj.type = 'application/pdf';
            obj.data = 'data:application/pdf;base64,' + b64;
			

			// >>>>>>>>>>>> AJUSTE CORRETO PARA CENTRALIZAR <<<<<<<<<<<
			obj.style.maxWidth = '100%';
			obj.style.width = '800px'; // Largura inicial confortável
			obj.style.height = '90vh';
			obj.style.display = 'block';
			obj.style.margin = '20px auto';
			obj.style.border = '1px solid #ccc'; // Opcional
			obj.style.boxShadow = '0 0 10px rgba(0,0,0,0.1)'; // Opcional
			// >>>>>>>>>>>> FIM AJUSTES <<<<<<<<<<<
	  
            this.renderer.appendChild(this.el.nativeElement, obj);

            var link = document.createElement('a');
            if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
              var byteCharacters = atob(b64);
            }
            link.innerHTML = 'Download PDF';
            link.download = 'boleto_' + Date.now() + '.pdf';
            link.href = 'data:application/octet-stream;base64,' + b64;
            link.className = 'btn btn-primary mr-2';
            this.renderer.appendChild(this.el2.nativeElement, link);
          }
    }
  }
